import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigPanelService {
  private configPanelOpenSubject = new BehaviorSubject<boolean>(false);
  configPanelOpen$ = this.configPanelOpenSubject.asObservable();

  openConfigPanel() {
    this.configPanelOpenSubject.next(true);
  }

  closeConfigPanel() {
    this.configPanelOpenSubject.next(false);
  }

  toggleConfigPanel() {
    this.configPanelOpenSubject.next(!this.configPanelOpenSubject.value);
  }
}